import type { ApiRoute, NoBody, NoQueryParams } from "../api"

export type MarketExportJobStatus = "COMPLETED" | "FAILED" | "PENDING"

export interface GetMarketExportJobPathParams {
	exportJobId: string
}

export interface MarketExportJobStatusView {
	downloadUrl?: string
	errorMessage?: string
	progress?: number
	status: MarketExportJobStatus
}

export const getMarketExportJobRoute: ApiRoute<
	GetMarketExportJobPathParams,
	NoQueryParams,
	NoBody,
	MarketExportJobStatusView
> = {
	buildUrl: (params) => `/export-market/jobs/${params.exportJobId}`,
	method: "get",
	path: "/export-market/jobs/:exportJobId",
}
